import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useLoggedIn } from "../routes/isLoggedIn";
import { RootState } from "../store";
import { useAnalytics } from "./AnalyticsContext";
import { VISITOR_EVENTS, PageVisitEventData } from "./events";
import { usePageTimer } from "../hooks/usePageTimer";

export const PageVisitTracker = () => {
  const { trackEvent, setUser } = useAnalytics();

  const isAuthenticated = useLoggedIn();
  const user = useSelector((state: RootState) => state.user);
  const location = useLocation();

  // Track page timing
  usePageTimer(user?.id, isAuthenticated);

  useEffect(() => {
    const pathname = location.pathname;

    const pageVisitData: PageVisitEventData = {
      page_path: pathname,
      page_title: document.title,
      is_authenticated: isAuthenticated,
      referrer: document.referrer || undefined,
    };

    if (isAuthenticated && user && user.id) {
      pageVisitData.user_id = user.id;
      setUser(user.id);
    }

    trackEvent(
      `${VISITOR_EVENTS.PAGE_VISITED} ${pathname}`,
      pageVisitData as Record<string, unknown>
    );
  }, [isAuthenticated, user?.id, location.pathname, setUser, trackEvent]);

  return null;
};
